let handler: (() => void) | null = null;

export function registerChatListingRefresh(fn: () => void): () => void {
  handler = fn;
  return () => {
    if (handler === fn) {
      handler = null;
    }
  };
}

export function notifyChatListingRefresh(): void {
  handler?.();
}
